import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import idCommon from '../../public/locales/id/common.json'
import enCommon from '../../public/locales/en/common.json'

// Inline resources (simpler than HTTP backend for M0).
// Each locale currently owns a single 'common' namespace — extend here
// when new namespaces are introduced (e.g. 'course', 'quiz').
export const resources = {
  id: {
    common: idCommon,
  },
  en: {
    common: enCommon,
  },
} as const

void i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'id',
    fallbackLng: 'en',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: {
      // React already escapes values by default.
      escapeValue: false,
    },
    returnNull: false,
  })

export default i18n
